export const setVerifiedUser = 'setVerifiedUser';
